module.exports = __webpack_public_path__ + "static/logo-ebc385458e03fdb24af078536af88065.svg";